const MoonVisual = ({ size = 200 }: { size?: number }) => {
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <div
        className="absolute inset-0 rounded-full animate-pulse-glow"
        style={{
          background: "radial-gradient(circle at 35% 35%, hsl(45 30% 90%), hsl(45 20% 70%), hsl(240 20% 30%))",
          boxShadow: `0 0 ${size / 3}px hsl(45 80% 60% / 0.4), 0 0 ${size}px hsl(270 60% 60% / 0.2)`,
        }}
      />
      {/* craters */}
      <div className="absolute rounded-full bg-foreground/5" style={{ width: size * 0.12, height: size * 0.12, top: "25%", left: "30%" }} />
      <div className="absolute rounded-full bg-foreground/5" style={{ width: size * 0.08, height: size * 0.08, top: "55%", left: "50%" }} />
      <div className="absolute rounded-full bg-foreground/5" style={{ width: size * 0.15, height: size * 0.15, top: "40%", left: "60%" }} />
    </div>
  );
};

export default MoonVisual;
